import $ from 'jquery';
import '../vendor/jquery-form';
import { organizationNumber, accountNumber } from './number-validation';
import * as DatoHjelper from './dato-hjelper';

const whitespaceRegEx = /\s/g;

function Form(el, customValidators) {
  this.el = el;
  this.texts = {};
  this.errorOccurred = false;

  this.customValidators = customValidators || [];

  this.inputs = el.find('input:not([type=hidden]):not([type=file]):not([type=submit]), .inputElement');
  this.formInvalidHjelpetekst = el.find('.hjelpetekst--form-invalid');
  this.storeInitialValues(this.inputs);

  this.listenForInputChange();
}

Form.CSS_ITEM = 'form-item';
Form.CSS_ITEM_CLEAN = 'form-item-clean';
Form.CSS_ITEM_DIRTY = 'form-item-dirty';
Form.CSS_ITEM_ERROR = 'form-item-error';
Form.CSS_ITEM_VALID = 'form-item-valid';

Form.DATA_SUBMITTED_ATTRIBUTE = 'submitted-text';

Form.prototype.neverDisableSubmit = function () {
  this.neverDisableSubmitButton = true;
  return this;
};

Form.prototype.preventMultipleSubmissions = function () {
  const self = this;
  const $submit = this.findSubmitButton();
  const whileSubmittingText = $submit.data(Form.DATA_SUBMITTED_ATTRIBUTE) || '';
  if (!whileSubmittingText) {
    console.warn(`Submitknappen i formet ${this.el.get(0).outerHTML} mangler tekst som skal vises mens man submitter formet i attributtet <input .. ${Form.DATA_SUBMITTED_ATTRIBUTE} = "Lagrer.." />`);
  }
  this.el.submit(() => {
    if (whileSubmittingText) {
      self.initialSubmitButtonText = $submit.text();
      $submit.val(whileSubmittingText);
      $submit.attr('disabled', 'disabled');
    }
  });
  return this;
};

Form.prototype.ajaxify = function (ignoreValidateOnSuccess) {
  const self = this;
  const $form = this.el;

  function clearErrors() {
    /* TODO inn med dette når vi har oversatt valideringsmeldinger.
    $form.find('.form-errormsg').remove();
    */
    self.errorOccurred = false;
    $form.find('.form-message').empty();
  }

  function showErrorNextToField() {
    return function (error) {
      const $errorInput = $form.find(`.form-item [name="${error.key}"]`);
      self.markInputError($errorInput);

      /* TODO inn med dette når vi har oversatt valideringsmeldinger.
      if ($errorInput.length) {
        $('<span class="form-errormsg">' +
          error.errors.join(' ') +
         '</span>').insertAfter($errorInput);
      }
      */
    };
  }

  function insertMessage(htmlClass, message) {
    const formErrorEl = $form.find('.form-message');
    const $span = $(`<span class="${htmlClass}">${message}</span>`);
    $span.click(() => $span.remove());

    if (formErrorEl.length) {
      formErrorEl.html($span);
    } else {
      const $error = $('<span class="form-message"></span>').append($span);
      const $submit = self.findSubmitButton();
      if ($submit.length) {
        $error.insertBefore($submit);
      } else {
        $form.append($error);
      }
    }
    return $span;
  }

  function insertErrorMessage(message) {
    insertMessage('form-global-errormsg', message);
  }

  $form.ajaxForm({
    beforeSend() {
      clearErrors();
    },
    success(req, type, httpCodeMsg) {
      if (!ignoreValidateOnSuccess) {
        clearErrors();
        self.validate();
      }
      // insertSuccessMessage($form, "Lagret!");

      self.SuccessFunction(req, type, httpCodeMsg);
    },
    error(req) {
      self.errorOccurred = true;
      self.validate();
      const body = req.responseJSON;
      if (req.status === 400) {
        // Serverside ModelState.isValid-feil
        if (body && body.error && body.values && body.values.length) {
          body.values.forEach(showErrorNextToField());
        }
      } else {
        // 500, etcs
        const message = (body && body.message) || 'En intern feil har oppstått. Vennligst forsøk å oppdatere siden, og ta kontakt hvis feilen vedvarer.';
        insertErrorMessage(message);
      }

      self.disableNavigationButton();
    },
  });

  return this;
};

function getValue($input) {
  const checkbox = $input[0].type === 'checkbox';
  if (checkbox) {
    return $input.prop('checked');
  }

  return $input.val();
}

function findInputWrapper($input) {
  return $input.closest(`.${Form.CSS_ITEM}`);
}

function isVerdiInvalid($input) {
  if (!$input.data('val-verdi')) return false;

  const value = getValue($input);

  if (!value && !$input.prop('required')) return false;

  const min = parseFloat(`${$input.data('val-verdi-min')}`.replace(',', '.'));
  const max = parseFloat(`${$input.data('val-verdi-max')}`.replace(',', '.'));
  const verdi = parseFloat(value.replace(',', '.'));

  const isValid = verdi >= min && verdi <= max;

  if (!isValid) return true;

  return false;
}

function isOrgNrInvalid($input) {
  if (!$input.data('val-orgnr')) return false;
  const value = getValue($input);
  if (!value && !$input.prop('required')) return false;
  const isValid = organizationNumber(value);
  const brregInvalidOrgNr = $input.data('invalid-orgnr');
  if (brregInvalidOrgNr && brregInvalidOrgNr === value) return true;
  if (!isValid) return true;
  if ($input.data('bbreg-gyldig') !== undefined) return !$input.data('bbreg-gyldig');
  return false;
}

function isAccountNrInvalid($input) {
  if (!$input.data('val-kontonr')) return false;
  const value = getValue($input);
  if (!value && !$input.prop('required')) return false;
  const isValid = accountNumber(value);
  const invalidKontoNr = $input.data('invalid-kontonr');
  if (invalidKontoNr && invalidKontoNr === value) return true;
  return !isValid;
}

/**
 * Check validation of input with attribute 'val-gyldigkostnad'.
 *
 * If the supplied value is not a number or outside given boundaries, kostnad is invalid.
 * */
function isEltohjulingKostnadInvalid($input) {
  if (!$input.data('val-gyldigeltohjulingkostnad')) {
    return false;
  }

  const value = getValue($input).replace(whitespaceRegEx, '');
  if (!value && !$input.prop('required')) {
    return false;
  }

  const valueAsFloat = parseFloat(value);
  if (Number.isNaN(valueAsFloat)) {
    return true;
  }

  return valueAsFloat < 1000.0 || valueAsFloat > 999999.99;
}

function isMaxDatoInvalid($input, value) {
  const harMaxDatoValidering = typeof $input.data('val-maksdato') !== 'undefined';
  if (!harMaxDatoValidering) {
    return false;
  }

  if (!DatoHjelper.isValid(value, DatoHjelper.Format.NorskDato)) {
    return true;
  }

  const maxTillattDato = $input.data('val-maksdato-dato');
  const datoErForGammel = DatoHjelper.isAfter(value, maxTillattDato);
  return datoErForGammel;
}

function isMinDatoInvalid($input, value) {
  const harMinDatoValidering = typeof $input.data('val-foreldet') !== 'undefined';
  if (!harMinDatoValidering) {
    return false;
  }

  if (!DatoHjelper.isValid(value, DatoHjelper.Format.NorskDato)) {
    return true;
  }

  const startDato = $input.data('soknad-dato');
  const maxMonth = $input.data('val-foreldet-antallmnd');
  const minTillattDato = DatoHjelper.subtractMonths(startDato, maxMonth);
  const datoErForGammel = DatoHjelper.isAfter(minTillattDato, value);
  return datoErForGammel;
}

function isEmptyRadioButtonGroup($input) {
  if (!$input.is(':radio')) {
    return false;
  }
  if (!$input.is(':visible')) {
    return false;
  }
  const name = $input.attr('name');
  const checkedButtons = $(`input[name="${name}"]:checked`);
  return checkedButtons.length === 0;
}

function isOpsjonKreverFakturaInvalid($input) {
  if (!$input.is('.kreverfaktura') || !$input.is(':checked')) {
    return false;
  }
  return $input.parent().parent().find('.utgifter--vedlegg li').length === 0;
}

function isRadioButtonInvalidChoice($input) {
  return $input.is('[value=nei]:radio:checked');
}

function inputIsValid(input) {
  const $input = $(input);

  if (!$input.is(':visible')) return true;

  if ($input.hasClass('inputElement')) {
    if (!$input.hasClass('obligatorisk')) return true;
    const $inputWrapper = findInputWrapper($input);
    return $inputWrapper.find('li').length !== 0;
  }

  const regex = $input.data('val-regex-pattern');
  const value = getValue($input);

  const required = !!$input[0].dataset.valRequired;

  const isRequiredAndEmpty = required && !value;
  if (isRequiredAndEmpty) {
    return false;
  }

  if (isEmptyRadioButtonGroup($input)) {
    return false;
  }

  if (isRadioButtonInvalidChoice($input)) {
    return false;
  }

  if (isOpsjonKreverFakturaInvalid($input)) {
    return false;
  }

  if (isVerdiInvalid($input, value)) {
    return false;
  }

  if (isMaxDatoInvalid($input, value)) {
    return false;
  }

  if (isMinDatoInvalid($input, value)) {
    return false;
  }

  if (isOrgNrInvalid($input)) {
    return false;
  }

  if (isAccountNrInvalid($input)) {
    return false;
  }

  if (isEltohjulingKostnadInvalid($input)) {
    return false;
  }

  const hasValueAndRegex = value && regex;
  if (hasValueAndRegex && !new RegExp(regex, 'gi').test(value)) {
    return false;
  }
  const valueMinRange = $input.data('val-range-min');
  if (valueMinRange !== undefined && parseFloat(value.replace(',', '.')) < valueMinRange) {
    return false;
  }

  return $input[0].validity.valid;
}

/**
 * Custom formatting of kostnad field with currency format
 * */
function formatEltohjulingkostnad($input) {
  const value = $input.val().replace(whitespaceRegEx, '');
  const formatter = new Intl.NumberFormat('nb', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
  const floatValue = parseFloat(value);
  if (Number.isNaN(floatValue)) {
    return;
  }

  const formattedValue = formatter.format(floatValue);

  $input.val(formattedValue);
}

function formatInputs($input) {
  if ($input.data('val-gyldigeltohjulingkostnad')) {
    formatEltohjulingkostnad($input);
  }
}

// To be overridden for each form
Form.prototype.SuccessFunction = function () {};

// To be overridden for each form
Form.prototype.enableNavigationButton = function () {};

// To be overridden for each form
Form.prototype.disableNavigationButton = function () {};

Form.prototype.storeInitialValues = function (inputs) {
  const self = this;
  inputs.each((i, input) => {
    const $input = $(input);
    const name = $input.attr('name');
    if (!name && !$input.is('.inputElement')) {
      console.error('Form: could not initialize form, not all <input>s have name` attributes', input);
    }
    self.texts[name] = getValue($input);
  });
};

Form.prototype.listenForInputChange = function () {
  const self = this;

  function handleFocusMoved(e) {
    const $input = $(e.currentTarget);

    if (!inputIsValid($input)) {
      self.markInputError($input);
    }

    formatInputs($input);
  }

  function handleValueChanged(e) {
    const $input = $(e.currentTarget);

    const name = $input.attr('name');
    const oldValue = self.texts[name];
    const value = getValue($input);
    const changed = oldValue !== value;

    if (inputIsValid($input)) {
      self.markInputValid($input);
    } else if (changed) {
      self.markInputDirty($input);
    } else {
      self.markInputClean($input);
    }
    self.enableButtonIfReadyForSubmit();
    self.showInvalidFormHjelpetekstIfFormIsInvalid();
  }

  this.el.on('blur', 'input', handleFocusMoved);

  this.el.on('keyup', 'input', handleValueChanged);
  this.el.on('change', 'input', handleValueChanged);
  this.el.on('input', 'input', handleValueChanged);
};

Form.prototype.validate = function () {
  const self = this;
  self.inputs.each((i, input) => {
    const $input = $(input);
    if (inputIsValid($input)) {
      self.markInputValid($input);
    } else {
      self.markInputError($input);
    }
  });
  self.showInvalidFormHjelpetekstIfFormIsInvalid();
  self.enableButtonIfReadyForSubmit();
  return this;
};

Form.prototype.enableButtonIfReadyForSubmit = function () {
  if (this.neverDisableSubmitButton) return this;

  const submitButton = this.findSubmitButton();
  if (this.isFormValid()) {
    submitButton.removeAttr('disabled');
    this.enableNavigationButton();
  } else {
    submitButton.attr('disabled', 'disabled');
    this.disableNavigationButton();
  }
  return this;
};

Form.prototype.isFormMarkedWithError = function () {
  return !!this.el.find('.form-item-error').length;
};

Form.prototype.showInvalidFormHjelpetekstIfFormIsInvalid = function () {
  if (this.isFormMarkedWithError() && this.formInvalidHjelpetekst.length) {
    this.formInvalidHjelpetekst.show();
  } else {
    this.formInvalidHjelpetekst.hide();
  }
};

Form.prototype.isFormValid = function (customInputs) {
  const inputs = customInputs || $.makeArray(this.inputs).map($);
  return inputs.every(inputIsValid) && this.customValidators.every(f => f() === true) && !this.errorOccurred;
};

Form.prototype.findSubmitButton = function () {
  return this.el.find('[type=submit]');
};

Form.prototype.findInputWrapper = findInputWrapper;

Form.prototype.removeAllFormClasses = function ($input) {
  const $inputWrapper = this.findInputWrapper($input);
  $inputWrapper.removeClass(Form.CSS_ITEM_CLEAN);
  $inputWrapper.removeClass(Form.CSS_ITEM_DIRTY);
  $inputWrapper.removeClass(Form.CSS_ITEM_ERROR);
  $inputWrapper.removeClass(Form.CSS_ITEM_VALID);
};

Form.prototype.markInputDirty = function ($input) {
  this.removeAllFormClasses($input);
  const $inputWrapper = this.findInputWrapper($input);
  $inputWrapper.addClass(Form.CSS_ITEM_DIRTY);
};

Form.prototype.markInputValid = function ($input) {
  this.removeAllFormClasses($input);
  const $inputWrapper = this.findInputWrapper($input);
  $inputWrapper.addClass(Form.CSS_ITEM_VALID);
};

Form.prototype.markInputClean = function ($input) {
  this.removeAllFormClasses($input);
  const $inputWrapper = this.findInputWrapper($input);
  $inputWrapper.addClass(Form.CSS_ITEM_CLEAN);
};

Form.prototype.markInputError = function ($input) {
  this.removeAllFormClasses($input);
  const $inputWrapper = this.findInputWrapper($input);
  $inputWrapper.addClass(Form.CSS_ITEM_ERROR);

  if ($input.is('.kreverfaktura') && $input.is(':checked')) {
    const $uploadContainer = $input.parent().parent().find('.utgifter--vedlegg').parent();
    const $uploadContainerWrapper = this.findInputWrapper($uploadContainer);
    $uploadContainerWrapper.addClass(Form.CSS_ITEM_ERROR);
  }
};

Form.prototype.markAllInputsAsError = function () {
  this.inputs.each((i, input) => this.markInputError($(input)));
};

export default function (formSelector, customValidators) {
  return new Form($(formSelector), customValidators);
}
